var render = function render(){var _vm=this,_c=_vm._self._c;return _c('res-select',{attrs:{"id":_vm.elementId,"readonly":_vm.readonly,"items":_vm.years,"attach":_vm.attachId,"loading":_vm.loading},model:{value:(_vm.selectedYear),callback:function ($$v) {_vm.selectedYear=$$v},expression:"selectedYear"}})
}
var staticRenderFns = []

export { render, staticRenderFns }